import IconButton from "@mui/material/IconButton";
import ViewSidebarOutlined from "@mui/icons-material/ViewSidebarOutlined";
import { useSidebar } from "@/common/hooks/useSidebar";

export function EvesSidebarToggle() {
  const { isOpen, toggle } = useSidebar();

  // Only rendered inside the Main layout, where SidebarContext provides the toggle
  if (!toggle) return null;

  return (
    <IconButton
      onClick={toggle}
      aria-label={isOpen ? "Collapse sidebar" : "Expand sidebar"}
      aria-expanded={isOpen}
      data-cy="sidebar-toggle"
      disableRipple
      sx={{
        p: "4px",
        ml: "-4px",
        mr: "20px",
        alignSelf: "center",
        color: "#FFFFFF",
        "&:hover": { backgroundColor: "transparent" },
        "&.Mui-focusVisible": { outline: "2px solid #FFFFFF", borderRadius: "4px" },
      }}
    >
      <ViewSidebarOutlined sx={{ fontSize: 24, color: "#FFFFFF", transform: "scaleX(-1)" }} />
    </IconButton>
  );
}